import {hoistCmp, uses} from '@xh/hoist/core';
import {WatchlistExpandedModel} from './WatchlistExpandedModel';
import {dialog} from '@xh/hoist/kit/blueprint';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {Icon} from '@xh/hoist/icon';
import {grid} from '@xh/hoist/cmp/grid';
import './WatchlistExpanded.scss';

/** Full watchlist quote board. Always uses the terminal look, whatever the display style setting is. */
export const watchlistExpanded = hoistCmp.factory<WatchlistExpandedModel>({
    model: uses(WatchlistExpandedModel),
    render({model}) {
        return dialog({
            className: 'rzx-style--terminal wl-expanded',
            style: {
                width: 1320,
                maxWidth: '95vw',
                height: 640
            },
            isOpen: model.isOpen,
            onClose: () => model.close(),
            title: 'Watch List',
            icon: Icon.eye(),
            item: panel({
                item: grid(),
                mask: model.apiTask
            })
        });
    }
});
